import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  getCurrentPayCycleStartDate,
  isDateInPreviousPayCycle,
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import { propertyAccountingPayrollColumnList } from '../../constants/MockData';
import _ from 'lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import moment from 'moment';
import { data } from 'jquery';

// Component used to Configure Payroll of Property Accounting and Centralized AR
class ConfigurePropertyAccountingPayroll extends React.Component {
  // Constructor to set initial state of component
  constructor(props) {
    super(props);
    this.state = {
      isInAddMode: false,
      configuration: [],
      selectedEditRowId: undefined,
      updateData: {
        payroll: 0,
        bonus: 0,
        burdenRatePercent: 0,
        applicableFrom: null,
        propertyAccountingPayrollConfigurationId: 0
      },
      propertyAccountingPayrollColumn: _.clone(propertyAccountingPayrollColumnList),
      isDelete: false,
      showWarningMessage: false,
      confirmMessage: '',
      propertyAccountingPayrollData: [],
      payrollConfigurationType: []
    };
  }

  // Get data before component is mounted
  componentDidMount() {
    this.getMasterData();
    window.scrollTo(0, 0);
  }

  // Get Master data from DB using API call
  getMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetPropertyAccountingPayroll,
        key: 'propertyAccountingPayrollData'
      },
      {
        url: API_URL.Users.GetPayrollConfigurationType,
        key: 'payrollConfigurationType'
      }
    ])
      .then(({ propertyAccountingPayrollData, payrollConfigurationType }) => {
        this._asyncRequest = null;
        if (propertyAccountingPayrollData.success !== true) {
          ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
        }

        this.setState({
          propertyAccountingPayrollData: propertyAccountingPayrollData.data || [],
          configuration: propertyAccountingPayrollData.config || [],
          payrollConfigurationType: payrollConfigurationType.data || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get payroll configuration data of Property Accounting and Centralized AR
  GetPropertyAccountingPayrollData = () => {
    apiRequest({
      url: API_URL.Users.GetPropertyAccountingPayroll
    }).then(({ data: response }) => {
      this.setState({
        propertyAccountingPayrollData: response || []
      });
    });
  };

  // Handle cancel event
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
  };

  // Check validations
  isValidForm = () => {
    let IsValid = true;
    const { updateData, propertyAccountingPayrollColumn } = this.state;
    propertyAccountingPayrollColumn.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ propertyAccountingPayrollColumn }, this.forceUpdate());
    return IsValid;
  };

  // Check if duplicate record is exists
  isPayrollExists = () => {
    const { updateData, propertyAccountingPayrollData } = this.state;
    const existingRecord = propertyAccountingPayrollData.find(y => moment(y.applicableFrom).format(DateFormat) === moment(updateData.applicableFrom).format(DateFormat) &&
      y.payrollConfigurationTypeId === updateData.payrollConfigurationTypeId && y.propertyAccountingPayrollConfigurationId !== updateData.propertyAccountingPayrollConfigurationId);
    if (existingRecord !== undefined) {
      const message = 'Applicable From: ' + moment(existingRecord.applicableFrom).format(DateFormat) + ' already exists. If you want to update any information please edit that particular record.';
      ShowToast(message, toastType.WARNING, 5000, 500);
      return true;
    }
    return false;
  }

  // Handle click event of Save button
  saveUpdatedRecord = () => {
    if (this.isPayrollExists() || !this.isValidForm()) { return false; } else {
      const newParam = this.state.updateData;
      const params = {
        payroll: newParam.payroll,
        bonus: newParam.bonus,
        burdenRatePercent: newParam.burdenRatePercent,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        propertyAccountingPayrollConfigurationId: newParam.propertyAccountingPayrollConfigurationId,
        payrollConfigurationTypeId: newParam.payrollConfigurationTypeId,
        StatusId: 1
      };
      this.SavePropertyAccountingPayroll(params);
    };
  }

  // Save payroll configuration into DB
  SavePropertyAccountingPayroll = (params) => {
    apiPost({
      url: API_URL.Users.UpdatePropertyAccountingPayrollConfiguration,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: ''
        }, () => this.GetPropertyAccountingPayrollData());
      } else {
        ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Check if Edit icon should be display or not
  IsEditVisible = (cellInfo) => {
    if (isDateInPreviousPayCycle(moment(cellInfo.applicableFrom).format(DateFormat))) {
      return false;
    }
    return true;
  }

  // Open record into Edit mode
  EditRecord = (cellInfo) => {
    const propertyAccountingPayrollColumn = _.cloneDeep(propertyAccountingPayrollColumnList);
    propertyAccountingPayrollColumn.forEach(x => {
      if (x.key === 'applicableFrom') {
        x.minDate = getCurrentPayCycleStartDate();
      }
      if (x.key === 'payroll' && cellInfo.payrollConfigurationTypeId?.toString() === '2') {
        x.disabled = true;
      }
    });
    this.setState({
      selectedEditRowId: { key: 'propertyAccountingPayrollConfigurationId', value: cellInfo.propertyAccountingPayrollConfigurationId },
      isInAddMode: false,
      updateData: { ...cellInfo },
      propertyAccountingPayrollColumn
    });
  }

  // Render Edit/Update/Cancel action buttons based on conditions
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.propertyAccountingPayrollConfigurationId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>{(IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_PROPERTY_ACCOUNTING_PAYROLL, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.EditRecord(cellInfo);
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          )}
            {(IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_PROPERTY_ACCOUNTING_PAYROLL, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
              <Tooltip title="Delete Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        }
      </>
    );
  };

  /**
 * delete record
 */
  deleteRecord(cellInfo) {
    this.setState({
      showWarningMessage: true,
      confirmMessage: 'Do you want to delete this record ?',
      updateData: cellInfo
    });
  };

  /**
 * handle dialog box click event
 * @param {*} e
 */
  onClickHandle(e) {
    if (e) {
      const newParam = this.state.updateData;
      const params = {
        payroll: newParam.payroll,
        bonus: newParam.bonus,
        burdenRatePercent: newParam.burdenRatePercent,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        propertyAccountingPayrollConfigurationId: newParam.propertyAccountingPayrollConfigurationId,
        payrollConfigurationTypeId: newParam.payrollConfigurationTypeId,
        StatusId: 2
      };
      this.SavePropertyAccountingPayroll(params);
    } else {
      this.setState({
        showWarningMessage: false,
        confirmMessage: ''
      });
    }
  }

  // Handle Edit event of values in the table
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const { propertyAccountingPayrollColumn, payrollConfigurationType } = this.state;
    const param = { ...this.state.updateData };
    if (fieldName === 'configurationType') {
      const valueOfConfigurationType = payrollConfigurationType.find((x) => x.configurationType === value);
      param.payrollConfigurationTypeId = (valueOfConfigurationType || {}).payrollConfigurationTypeId;
      param[fieldName] = value.trim();
      propertyAccountingPayrollColumn.forEach(x => {
        if (x.key === 'payroll' && param.payrollConfigurationTypeId?.toString() === '2') {
          x.disabled = true;
          x.isRequired = false;
          param.payroll = 0;
        } else if (x.key === 'payroll') {
          x.disabled = false;
          x.isRequired = true;
        }
      });
    } else {
      param[fieldName] = value;
    }
    isGridFormValid(value, propertyAccountingPayrollColumn.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, propertyAccountingPayrollColumn });
  };

  // Add new record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const propertyAccountingPayrollColumn = _.cloneDeep(propertyAccountingPayrollColumnList);
    propertyAccountingPayrollColumn.forEach(x => {
      if (x.key === 'applicableFrom') {
        x.minDate = getCurrentPayCycleStartDate();
      }
    });

    const rowNew = {
      payroll: 0,
      bonus: 0,
      burdenRatePercent: 0,
      applicableFrom: null,
      propertyAccountingPayrollConfigurationId: 0
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'propertyAccountingPayrollConfigurationId', value: 0 }, updateData: rowNew, propertyAccountingPayrollColumn });
  };

  // Render components based on conditions
  render() {
    const { payrollConfigurationType, configuration, propertyAccountingPayrollData, isInAddMode, selectedEditRowId, updateData, propertyAccountingPayrollColumn } = this.state;
    const EditSource = [];
    EditSource.push(
      { key: 'payrollConfigurationType', data: payrollConfigurationType }
    );
    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => { this.onClickHandle(isValid); }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Property Accounting and Centralized AR Payroll Configuration
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(propertyAccountingPayrollColumn, configuration, [])}
                  data={propertyAccountingPayrollData}
                  config={propertyAccountingPayrollColumn}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={selectedEditRowId}
                  isInAddMode={isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={updateData}
                  isInline={true}
                  AddNewRecord={{ action: this.AddNewRecord, title: 'Add New Property Accounting and Centralized AR Payroll', visible: IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_PROPERTY_ACCOUNTING_PAYROLL, SECTIONS.ADD_EDIT) }}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}

export default ConfigurePropertyAccountingPayroll;
